import { type ReactElement } from "react";

import { useIsAdmin } from "../../guards/useRole";
import { useAuth } from "../../providers/auth-provider";

export const NO_SEARCHES_MESSAGE =
  "Keine Suchen mehr verfügbar. Bitte einen Admin um weiteres Such-Kontingent.";

/** Admins have unlimited searches; recruiters use one per sent job. The
 * backend's 403 stays the authoritative check for a stale client cache. */
export function useSearchQuota(): {
  isAdmin: boolean;
  searchesRemaining: number;
  canStartSearch: boolean;
} {
  const isAdmin = useIsAdmin();
  const { user } = useAuth();
  const searchesRemaining = user?.searchesRemaining ?? 0;
  return { isAdmin, searchesRemaining, canStartSearch: isAdmin || searchesRemaining > 0 };
}

/** „Verfügbare Suchen: N" under a form heading, for recruiters only. */
export function SearchQuotaHint(): ReactElement | null {
  const { isAdmin, searchesRemaining } = useSearchQuota();
  if (isAdmin) return null;
  return (
    <p
      className={`mt-1 text-sm ${searchesRemaining > 0 ? "text-text-tertiary" : "text-danger-700"}`}
    >
      {searchesRemaining > 0 ? `Verfügbare Suchen: ${searchesRemaining}` : NO_SEARCHES_MESSAGE}
    </p>
  );
}
